import { ofTimeOnlyWithZ } from "./utils/time-utils";

export const defaultSessionStart = ofTimeOnlyWithZ("08:00Z");
export const defaultSessionEnd = ofTimeOnlyWithZ("22:00Z");
